import PoeAlternativePage from '@/components/Pages/PoeAlternativePage';

export default PoeAlternativePage;
